import React, { useEffect, useState } from "react";
import {
  Card,
  Box,
  Button,
  IconButton,
  TextField,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
} from "@material-ui/core";
import _ from "lodash";
import { useQuery, useMutation } from "@apollo/client";
import { connect } from "react-redux";
import {
  modulesFunctionalityByModuleIdQuery,
  updateModuleFunctionalityOrderMutation,
} from "./ModulesGqlQuery";
import Spinner from "../common/Spinner";
import FunctionalityPermissionSettingDialog from "./FunctionalityPermissionSettingDialog";
import EditIcon from "@material-ui/icons/Edit";
import AddIcon from "@material-ui/icons/Add";
import CloseIcon from "@material-ui/icons/Close";
import AddModuleFunctionality from "./AddModuleFunctionality";
import ReactDragListView from "react-drag-listview/lib/index.js";
import DragIndicatorIcon from "@material-ui/icons/DragIndicator";
import SaveIcon from "@material-ui/icons/Save";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
const ModuleFunctionalityList = (props) => {
  const [modulesFunctionalityList, setModulesFunctionalityList] = useState([]);
  const [openPermissionDialog, setOpenPermissionDialog] = useState(false);
  const [permissionsList, setPermissionsList] = useState([]);
  const [isUpdateOrder, setIsUpdateOrder] = useState(false);
  const [editingFunctionality, setEditingFunctionality] = useState({});
  const [
    openAddModuleFunctionalityDialog,
    setOpenAddModuleFunctionalityDialog,
  ] = useState(false);
  const [moduleFunctionality, setModuleFunctionality] = useState("");

  const {
    data: modulesFunctionalityByModuleIdData,
    loading: modulesFunctionalityByModuleIdLoading,
    refetch: modulesFunctionalityByModuleIdRefetch,
  } = useQuery(modulesFunctionalityByModuleIdQuery, {
    variables: {
      moduleId: parseInt(props.moduleId),
    },
    fetchPolicy: "network-only",
  });

  const [updateFunctionalityOrder] = useMutation(
    updateModuleFunctionalityOrderMutation,
  );

  useEffect(() => {
    if (
      modulesFunctionalityByModuleIdData &&
      modulesFunctionalityByModuleIdData.modulesFunctionalityByModuleId
    ) {
      setModulesFunctionalityList(
        modulesFunctionalityByModuleIdData.modulesFunctionalityByModuleId,
      );
    } else {
      setModulesFunctionalityList([]);
    }
  }, [modulesFunctionalityByModuleIdData]);

  var height = props.height || window.innerHeight;

  const tableBoxStyle = {
    borderRadius: "6px",
    overflowY: "auto",
    backgroundColor: "#fff",
    maxHeight: height - 110,
  };

  const rowStyle = {
    display: "flex",
    minHeight: "50px",
    borderBottom: "1px solid #dfe3eb",
  };

  const leftCellStyle = {
    width: "30%",
    padding: "12px 16px",
    display: "flex",
    alignItems: "center",
    fontWeight: 500,
    fontSize: "14px",
  };

  const rightCellStyle = {
    width: "70%",
    padding: "12px 16px",
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "8px",
  };

  const dragProps = {
    onDragEnd: function(fromIndex, toIndex) {
      if (fromIndex === toIndex || fromIndex < 0 || toIndex < 0) {
        return;
      }

      setModulesFunctionalityList(function(previousList) {
        const activeItems = previousList.filter(function(item) {
          return !item.isRemove;
        });

        const removedItems = previousList.filter(function(item) {
          return item.isRemove;
        });

        const updatedList = [...activeItems];

        const movedItem = updatedList.splice(fromIndex, 1)[0];

        updatedList.splice(toIndex, 0, movedItem);

        return [...updatedList, ...removedItems];
      });
    },

    nodeSelector: ".permission-row",

    handleSelector: ".drag-handle",
  };

  const handleFunctionalityNameChange = (id, value) => {
    setModulesFunctionalityList((previousList) =>
      previousList.map((item) =>
        item.id === id
          ? {
              ...item,
              functionalityDisplayName: value,
            }
          : item,
      ),
    );
  };

  const handleEditFunctionalityName = (id, value) => {
    setEditingFunctionality((previous) => ({
      ...previous,
      [id]: value,
    }));
  };

  const handleSaveFunctionalityName = (id) => {
    const value = editingFunctionality[id];

    setModulesFunctionalityList((previousList) =>
      previousList.map((item) =>
        item.id === id
          ? {
              ...item,
              functionalityDisplayName:
                value && value.trim()
                  ? value.trim()
                  : item.functionalityDisplayName,
            }
          : item,
      ),
    );

    setEditingFunctionality((previous) => {
      const updated = { ...previous };
      delete updated[id];
      return updated;
    });
  };
  const handleCancelFunctionalityName = (id) => {
    setEditingFunctionality((previous) => {
      const updated = { ...previous };
      delete updated[id];
      return updated;
    });
  };

  const handleUpdateOrder = async () => {
    try {
      const payload = modulesFunctionalityList.map((item, index) => ({
        id: item.id,
        functionalityName: item.functionalityName,
        lineOrder: index + 1,
        functionalityDisplayName: item.functionalityDisplayName || "",
        moduleId : parseInt(props.moduleId)
      }));


      await updateFunctionalityOrder({
        variables: {
          moduleFunctionalities: payload,
        },
      })
        .then(() => {
          modulesFunctionalityByModuleIdRefetch();

          setIsUpdateOrder(false);
        })
        .catch((err) => {
          setIsUpdateOrder(false);
        });
    } catch (error) {
      console.error("Update order error:", error);
    }
  };
  return (
    <>
      <div style={{ height: height }}>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: 8,
          }}
        >
          {isUpdateOrder ? (
            <Box>
              <Button
                variant="contained"
                color="primary"
                // startIcon={<EditIcon />}
                onClick={() => {
                  setModulesFunctionalityList(
                    modulesFunctionalityByModuleIdData.modulesFunctionalityByModuleId,
                  );
                  setIsUpdateOrder(false);
                }}
                //  disabled={!newGroupName.trim()}
                style={{
                  minWidth: 120,
                  textTransform: "none",
                  marginRight: 8,
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                // startIcon={<EditIcon />}
                onClick={handleUpdateOrder}
                //  disabled={!newGroupName.trim()}
                style={{
                  minWidth: 120,
                  textTransform: "none",
                }}
              >
                Save
              </Button>
            </Box>
          ) : (
            <Box>
              <Button
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
                onClick={() => setOpenAddModuleFunctionalityDialog(true)}
                //  disabled={!newGroupName.trim()}
                style={{
                  minWidth: 120,
                  textTransform: "none",
                  marginRight: 8,
                }}
              >
                Add Module Functionality
              </Button>

              <Button
                variant="contained"
                color="primary"
                startIcon={<EditIcon />}
                onClick={() => setIsUpdateOrder(true)}
                //  disabled={!newGroupName.trim()}
                style={{
                  minWidth: 120,
                  textTransform: "none",
                }}
              >
                Update Order
              </Button>
            </Box>
          )}
        </div>
        {isUpdateOrder ? (
          <Card>
            {modulesFunctionalityByModuleIdLoading && <Spinner />}

            {modulesFunctionalityList.length ? (
              <>
                <ReactDragListView {...dragProps}>
                  <div style={tableBoxStyle}>
                    {modulesFunctionalityList.map((j, index) => (
                      <div
                        key={j.id || index}
                        className="permission-row"
                        style={{
                          ...rowStyle,
                          display: "flex",
                          alignItems: "center",
                          borderBottom:
                            index === modulesFunctionalityList.length - 1
                              ? "none"
                              : rowStyle.borderBottom,
                        }}
                      >
                        {/* DRAG HANDLE */}
                        <Box
                          className="drag-handle"
                          style={{
                            width: 34,
                            height: 38,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#9ca3af",
                            cursor: "grab",
                            flexShrink: 0,
                          }}
                        >
                          <DragIndicatorIcon fontSize="small" />
                        </Box>

                        {/* FUNCTIONALITY NAME */}
                        <div
                          style={{
                            ...leftCellStyle,
                            flex: 1,
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                          }}
                        >
                          <TextField
                            size="small"
                            variant="outlined"
                            value={j.functionalityDisplayName || ""}
                            onChange={(event) => {
                              const value = event.target.value;

                              setModulesFunctionalityList((previousList) =>
                                previousList.map((item) =>
                                  item.id === j.id
                                    ? {
                                        ...item,
                                        functionalityDisplayName: value,
                                      }
                                    : item,
                                ),
                              );
                            }}
                            placeholder="Functionality name"
                            style={{
                              flex: 1,
                              maxWidth: 350,
                            }}
                            InputProps={{
                              style: {
                                fontSize: 14,
                              },
                            }}
                          />

                          <span
                            style={{
                              fontSize: "12px",
                              color: "#6b7280",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {`(${j.functionalityPortal})`}
                          </span>
                        </div>

                        {/* PERMISSIONS */}
                        <div style={rightCellStyle}>
                          {_.uniqBy(j.permissions || [], "id").length
                            ? _.uniqBy(j.permissions || [], "id").map(
                                (pData, pIdx) => {
                                  if (pData.permissionName === "NEW_LINE") {
                                    return (
                                      <Box
                                        key={`new-line-${pIdx}`}
                                        style={{
                                          flexBasis: "100%",
                                          width: "100%",
                                          display: "flex",
                                          alignItems: "center",
                                          marginLeft: -2.6,
                                          marginTop: pIdx === 0 ? -0.3 : 6,
                                          marginBottom: 0.5,
                                          padding: 0,
                                        }}
                                      >
                                        <span
                                          style={{
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "#565656",
                                            whiteSpace: "nowrap",
                                            flexShrink: 0,
                                          }}
                                        >
                                          {pData.permissionDisplayName}
                                        </span>

                                        <Box
                                          style={{
                                            flex: 1,
                                            height: "0.5px",
                                            backgroundColor: "#DFE3EB",
                                            marginLeft: "8px",
                                          }}
                                        />
                                      </Box>
                                    );
                                  }

                                  return (
                                    <span
                                      key={pIdx}
                                      style={{
                                        display: "inline-flex",
                                        borderRadius: "14px",
                                        padding: "4px 12px",
                                        fontSize: "13px",
                                        backgroundColor: "#edf1f7",
                                        color: "#324157",
                                      }}
                                    >
                                      {pData.permissionDisplayName}
                                    </span>
                                  );
                                },
                              )
                            : ""}
                        </div>
                      </div>
                    ))}
                  </div>
                </ReactDragListView>

                {/* BOTTOM BUTTONS */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    padding: "16px",
                    borderTop: "1px solid #e5e7eb",
                    marginTop: "8px",
                    gap: "8px",
                  }}
                >
                  <Button
                    variant="outlined"
                    onClick={() => setIsUpdateOrder(false)}
                    style={{
                      minWidth: 100,
                      textTransform: "none",
                    }}
                  >
                    Cancel
                  </Button>

                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<SaveIcon />}
                    onClick={handleUpdateOrder}
                    style={{
                      minWidth: 120,
                      textTransform: "none",
                    }}
                  >
                    Save
                  </Button>
                </div>
              </>
            ) : (
              <div
                style={{
                  padding: "16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                No functionality available
              </div>
            )}
          </Card>
        ) : (
          <Card>
            {modulesFunctionalityByModuleIdLoading && <Spinner />}

            {modulesFunctionalityList.length ? (
              <div style={tableBoxStyle}>
                {modulesFunctionalityList.map((j, index) => (
                  <div
                    key={j.id || index}
                    style={{
                      ...rowStyle,
                      borderBottom:
                        index === modulesFunctionalityList.length - 1
                          ? "none"
                          : rowStyle.borderBottom,
                    }}
                  >
                    {/* FUNCTIONALITY NAME */}
                    <div style={leftCellStyle}>
                      {j.functionalityDisplayName || "-"}

                      <span
                        style={{
                          fontSize: "12px",
                          marginLeft: "4px",
                        }}
                      >
                        {` (${j.functionalityPortal})`}
                      </span>

                      {/* EDIT PERMISSION */}
                      <IconButton
                        size="small"
                        onClick={() => {
                          setPermissionsList(
                            j.permissions.map((p) => ({
                              ...p,
                              moduleFunctionalityName: j.functionalityName,
                              functionalityDisplayName:
                                j.functionalityDisplayName,
                            })),
                          );

                          setModuleFunctionality({
                            moduleFunctionalityName: j.functionalityName,
                            functionalityDisplayName:
                              j.functionalityDisplayName,
                          });

                          setOpenPermissionDialog(true);
                        }}
                        style={{
                          color: "#9ca3af",
                        }}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </div>

                    {/* PERMISSIONS */}
                    <div style={rightCellStyle}>
                      {_.uniqBy(j.permissions || [], "id").length
                        ? _.uniqBy(j.permissions || [], "id").map(
                            (pData, pIdx) => {
                              if (pData.permissionName === "NEW_LINE") {
                                return (
                                  <Box
                                    key={`new-line-${pIdx}`}
                                    style={{
                                      flexBasis: "100%",
                                      width: "100%",
                                      display: "flex",
                                      alignItems: "center",
                                      marginLeft: -2.6,
                                      marginTop: pIdx === 0 ? -0.3 : 6,
                                      marginBottom: 0.5,
                                      padding: 0,
                                    }}
                                  >
                                    <Box
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        flexShrink: 0,
                                      }}
                                    >
                                      <span
                                        style={{
                                          fontWeight: 500,
                                          fontSize: "14px",
                                          color: "#565656",
                                          whiteSpace: "nowrap",
                                          flexShrink: 0,
                                        }}
                                      >
                                        {pData.permissionDisplayName}
                                      </span>

                                      {pData.description && (
                                        <Tooltip
                                          title={pData.description}
                                          arrow
                                          placement="right"
                                        >
                                          <InfoOutlinedIcon
                                            style={{
                                              color: "#6b7280",
                                              cursor: "pointer",
                                              width: "16px",
                                              height: "16px",
                                              // marginBottom: "-5px",
                                              marginLeft: "4px",
                                            }}
                                          />
                                        </Tooltip>
                                      )}
                                    </Box>

                                    <Box
                                      style={{
                                        flex: 1,
                                        height: "0.5px",
                                        backgroundColor: "#DFE3EB",
                                        marginLeft: "8px",
                                      }}
                                    />
                                  </Box>
                                );
                              }

                              return (
                                <Tooltip
                                  title={pData.description}
                                  arrow
                                  placement="top"
                                >
                                  <span
                                    key={pIdx}
                                    style={{
                                      display: "inline-flex",
                                      borderRadius: "14px",
                                      padding: "4px 12px",
                                      fontSize: "13px",
                                      backgroundColor: "#edf1f7",
                                      color: "#324157",
                                    }}
                                  >
                                    {pData.permissionDisplayName}
                                  </span>
                                </Tooltip>
                              );
                            },
                          )
                        : ""}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div
                style={{
                  padding: "16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                No functionality available
              </div>
            )}
          </Card>
        )}
      </div>

      <FunctionalityPermissionSettingDialog
        openConnectDialog={openPermissionDialog}
        permissionsList={permissionsList}
        onSuccess={() => {
          modulesFunctionalityByModuleIdRefetch();
          setOpenPermissionDialog(false);
        }}
        exitAddModal={() => {
          setOpenPermissionDialog(false);
        }}
        moduleFunctionality={moduleFunctionality}
      />

      <Dialog
        fullWidth={true}
        scroll={"paper"}
        maxWidth="sm"
        classes={{
          paper: "popoverOverflow",
        }}
        disableBackdropClick
        open={openAddModuleFunctionalityDialog}
        onClose={() => setOpenAddModuleFunctionalityDialog(false)}
      >
        <DialogTitle
          // className="popoverOverflow"
          // className={dialogTitle}
          style={{
            padding: 5,
            backgroundColor: "#3F51B5",
            color: "#fff",
          }}
        >
          <div
            style={{
              flexDirection: "row",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography style={{ marginLeft: 8, fontSize: 18 }}>
              Add Module Functionality
            </Typography>
            <IconButton
              onClick={() => setOpenAddModuleFunctionalityDialog(false)}
            >
              <CloseIcon style={{ color: "white" }} color="fff" />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent
        // classes={{
        //   root: "popoverOverflow",
        // }}
        >
          <AddModuleFunctionality
            onSuccess={() => {
              modulesFunctionalityByModuleIdRefetch();
              setOpenAddModuleFunctionalityDialog(false);
            }}
            props={props}
            moduleId={props.moduleId}
            handleClose={() => setOpenAddModuleFunctionalityDialog(false)}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

const mapStateToProps = ({}) => {
  return {};
};

export default connect(mapStateToProps)(ModuleFunctionalityList);
